export default {
    GeneralInfos: [],
    Products: [],
    Images: [],
    Slides: [],
    Keywords: [],
    References: [],
    Videos: [],
    Social: [],
}